var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EventStatisticsConfig.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-1164d42d!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EventStatisticsConfig.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/event/EventStatisticsConfig.vue
// module id = 920
// module chunks = 2